import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from 'axios'

import type { Design } from './designs'

interface BrandAnalysisInput {
  brand: {
    colors: { hex: string; name: string; usage: string }[]
    visualStyle: string
    designDirective?: string
  }
  recommendedStyles: string[]
}

interface GenerateDesignsBody {
  prompt: string
  subjectImageUrls?: string[]
  trends?: string[]
  creativityLevel?: 'protected' | 'balanced' | 'wild'
  brandAnalysis?: BrandAnalysisInput
}

export const useGenerateDesigns = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (body: GenerateDesignsBody) =>
      axios
        .post<Design[]>('/designs/generate', body)
        .then(({ data }) => data),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['designs'] })
    }
  })
}
